export default class ConsumerLists {
  constructor() {
    this.require = {
      container: "^consumerContainer"
    };
    this.bindings = {
      consumerId: "@"
    };
  }

  templateUrl($element, $attrs) {
    return $attrs.templateUrl || "consumer-lists.html";
  }
}

angular.module("emun.consumer").component("consumerLists", new ConsumerLists());
